import type { Subdomain } from '@awork/features/workspace/models/workspace.model'

export interface AuthResponse {
  passwordlessEnabled?: boolean
  resource: string
  token_type: string
  expires_in: number
  access_token?: string
  refresh_token?: string
  subdomain: Subdomain
  userId?: string
  email?: string
}

export enum SocialConnectErrors {
  NoUserLinked = 'no-user-linked',
  SocialLoginNotLinked = 'social-login-not-linked',
  EmailDomainNotAllowed = 'email-domain-not-allowed',
  NeverLoggedIn = 'never-logged-in',
  SocialLoginNotAllowed = 'social-login-not-allowed'
}

export class LoginData {
  email: string
  name: string
  initials: string
  image?: string
}

export interface MfaConfiguration {
  mfaEnabled: boolean
  providers: MfaProvider[]
  authenticatorUrl?: string
}

export interface AuthorizedClientApplication {
  clientId: string
  displayName: string
  scopes: string[]
  authorizedOn?: string
}

export interface AuthorizedClientApplicationRevocationResponse {
  revokedClientCount: number
  revokedRefreshTokenCount: number
}

export enum MfaProvider {
  Email = 'Email',
  Authenticator = 'Authenticator'
}
